/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Pro_1Inputs */

const en_signup_feature_pro_1 = /** @type {(inputs: Signup_Feature_Pro_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three (3) user licenses`)
};

const fr_signup_feature_pro_1 = /** @type {(inputs: Signup_Feature_Pro_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trois (3) licences utilisateur`)
};

const de_signup_feature_pro_1 = /** @type {(inputs: Signup_Feature_Pro_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drei (3) Benutzerlizenzen`)
};

const it_signup_feature_pro_1 = /** @type {(inputs: Signup_Feature_Pro_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tre (3) licenze utente`)
};

const ru_signup_feature_pro_1 = /** @type {(inputs: Signup_Feature_Pro_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Три (3) пользовательские лицензии`)
};

const es_signup_feature_pro_1 = /** @type {(inputs: Signup_Feature_Pro_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tres (3) licencias de usuario`)
};

const zh_cn2_signup_feature_pro_1 = /** @type {(inputs: Signup_Feature_Pro_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`三 (3) 个用户许可证`)
};

const ja_signup_feature_pro_1 = /** @type {(inputs: Signup_Feature_Pro_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3つのユーザーライセンス`)
};

const hi_signup_feature_pro_1 = /** @type {(inputs: Signup_Feature_Pro_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तीन (3) उपयोगकर्ता लाइसेंस`)
};

const pt_pt2_signup_feature_pro_1 = /** @type {(inputs: Signup_Feature_Pro_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Três (3) licenças de usuário`)
};

/**
* | output |
* | --- |
* | "Three (3) user licenses" |
*
* @param {Signup_Feature_Pro_1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_1 = /** @type {((inputs?: Signup_Feature_Pro_1Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_1Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_feature_pro_1(inputs)
	if (locale === "de") return de_signup_feature_pro_1(inputs)
	if (locale === "it") return it_signup_feature_pro_1(inputs)
	if (locale === "ru") return ru_signup_feature_pro_1(inputs)
	if (locale === "es") return es_signup_feature_pro_1(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_feature_pro_1(inputs)
	if (locale === "ja") return ja_signup_feature_pro_1(inputs)
	if (locale === "hi") return hi_signup_feature_pro_1(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_feature_pro_1(inputs)
	return en_signup_feature_pro_1(inputs)
});